import { GridOptions, ICellRenderer, ICellRendererParams } from 'ag-grid-community';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { DashboardService } from '../../dashboard.service';
import { TakeOwnershipData } from './take-ownership.model';
import { TakeOwnershipService } from './take-ownership.service';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-take-ownership',
    templateUrl: './take-ownership.component.html',
    styleUrls: ['./take-ownership.component.scss']
})
export class TakeOwnershipComponent implements OnInit {
    @ViewChild('takeOwnershipGrid') agGrid: AgGridAngular;
    @Output() closed = new EventEmitter<void>();

    private setupGridTimer: number;

    public gridOptions: GridOptions = null;
    public data: TakeOwnershipData[] = [];
    public dashboards: any[] = [];

    public showLoader: boolean = false;

    private isFirstLoad: boolean = true;

    constructor(
        private agGridHelperService: AgGridHelperService,
        private dashboardService: DashboardService,
        private localizationService: CVLocalizationService,
        private service: TakeOwnershipService
    ) {
        this.ngOnInitAsync();
    }

    ngOnInit(): void {
    }

    async ngOnInitAsync() {
        this.showLoader = true;

        await this.loadData();

        if (!this.agGrid?.api) {
            this.setupGrid();
        }

        this.showLoader = false;
    }

    async loadData() {
        // clear data
        this.data = [];

        if (this.isFirstLoad) {
            await this.localizationService.GetSection('Common');
        }

        await this.dashboardService.loadExistingDashboardsAndGroups();
        this.dashboards = this.dashboardService.availableDashboards;
        this.dashboards.forEach(dashboard => {
            this.data.push({
                Data: dashboard,
                CanTakeOwnership: false
            });
        });

        let inactiveDashboards = await this.service.loadInactiveDashboards();
        if (inactiveDashboards != undefined) {
            inactiveDashboards.forEach(dashboard => {
                this.data.push({
                    Data: dashboard,
                    CanTakeOwnership: true
                })
            });
        }
    }

    setupGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            onGridReady: params => {
                this.queueUpdateGrid();
            },
            getRowId: ({data: rowData}) => rowData.Data.DashboardID,
            context: {
                takeOwnership: this.takeOwnership.bind(this)
            }
        });

        // Pushing rows defined in design
        this.gridOptions.columnDefs.push({
            field: 'favorite',
            headerName: 'FAVORITE',
            width: 100,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'Data.DashboardName',
            headerName: 'NAME',
            width: 150,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'sharedWith',
            headerName: 'SHARED WITH',
            width: 125,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'Data.CreatedBy',
            headerName: 'OWNERS',
            width: 125,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'Data.DashboardDescription',
            headerName: 'DESCRIPTION',
            width: 150,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'Data.LastViewDate',
            headerName: 'LAST VIEWED',
            width: 115,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            field: 'modified',
            headerName: 'MODIFIED',
            width: 115,
            resizable: true
        });
        this.gridOptions.columnDefs.push({
            cellRenderer: ActionCellRenderer,
            headerName: 'ACTION',
            width: 125,
            resizable: false
        });
    }

    queueUpdateGrid() {
        if (!this.agGrid?.api) {
            return;
        }

        if (this.setupGridTimer) {
            clearTimeout(this.setupGridTimer);
            this.setupGridTimer = null;
        }

        this.dashboards.forEach(dashboard => {
            let temp = dashboard;
        })

        this.setupGridTimer = window.setTimeout(() => {
            this.setupGridTimer = null;
            this.agGrid?.api.setGridOption('rowData', this.data);
        }, 500);
    }

    async takeOwnership(params: TakeOwnershipData) {
        this.service.takeOwnership(params.Data);
        await this.loadData();
        this.queueUpdateGrid();
    }

    close() {
        this.closed.emit();
    }
}

class ActionCellRenderer implements ICellRenderer {
    element: HTMLDivElement;

    init(params: ICellRendererParams) {
        this.onUpdate(params);
    }

    getGui() { return this.element; }

    refresh(params: ICellRendererParams) {
        this.onUpdate(params);
        return true;
    }

    private onUpdate(params: ICellRendererParams) {
        if (params.data.CanTakeOwnership) {
            this.element = document.createElement("div");
            $(this.element).addClass('d-flex justify-content-between');
            this.element.innerHTML = `<button type="button" class="icon-btn fill-casper">` +
                `<span class="icon-16 fill-hover-valyrianSteel">Take Ownership</span>` +
                `</button>`;
            $(this.element).find("button")[0].addEventListener("click", () => params.context.takeOwnership(params.data));
        }
    }
}
